/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import { APP_BASE_HREF } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule } from '@angular/core';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { HttpModule } from '@angular/http';
import { CoreModule } from './@core/core.module';

import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { ThemeModule } from './@theme/theme.module';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';

// import { GraphQLModule } from './graphql.module';
import { DatabaseService } from './services/datadase.service';
import { SessionService } from './services/session.service';
import { AuthService } from './auth/auth.service';
import { AuthGuard } from './auth/auth.guard';
import { SigninComponent } from '../app/pages/signin/signin.component';
import { ValidSession } from '../app/pages/valid-session/valid-session.component';

import { AgGridModule } from 'ag-grid-angular';
// import { SortablejsModule } from 'angular-sortablejs';

import { environment } from '../environments/environment';
import { AsyncPipe } from '../../node_modules/@angular/common';
import { AngularFireMessagingModule } from '@angular/fire/messaging';
import { AngularFireDatabaseModule } from '@angular/fire/database';
import { AngularFireAuthModule } from '@angular/fire/auth';
import { AngularFireModule } from '@angular/fire';

import { MessagingService } from './services/push.service';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core'
import { TranslateHttpLoader } from '@ngx-translate/http-loader';


@NgModule({
  declarations: [
    AppComponent,
    SigninComponent,
    ValidSession
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    HttpModule,
    AppRoutingModule,
    NgSelectModule,
    NgbModule.forRoot(),
    ThemeModule.forRoot(),
    CoreModule.forRoot(),
    AgGridModule.withComponents([]),
    // SortablejsModule.forRoot({
    //   animation: 200,
    // }),
    AngularFireDatabaseModule,
    AngularFireAuthModule,
    AngularFireMessagingModule,
    AngularFireModule.initializeApp(environment.firebase),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: httpTranslateLoader,
        deps: [HttpClient]
      }
    })

  ],
  bootstrap: [AppComponent],
  providers: [
    MessagingService,
    AsyncPipe,
    AuthGuard,
    AuthService,
    DatabaseService,
    SessionService,
    { provide: APP_BASE_HREF, useValue: '/' },
  ],
  exports: [TranslateModule]
})
export class AppModule {
}

export function httpTranslateLoader(http: HttpClient){
  return new TranslateHttpLoader(http);
}
